import { render, staticRenderFns } from "./Dashboard-aldisued.vue?vue&type=template&id=2d432358&scoped=true&"
import script from "./Dashboard-aldisued.vue?vue&type=script&lang=js&"
export * from "./Dashboard-aldisued.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-aldisued.vue?vue&type=style&index=0&id=2d432358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d432358",
  null
  
)

export default component.exports